import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { userLogout, translate, toggleSidebar } from 'react-admin';
import PropTypes from 'prop-types';
import MenuIcon from '@material-ui/icons/Menu';

import Logout from './components/LogoutButton';
import styles from './styles.module.scss';
import logo from './assets/OBS_ISO.png';
import arrow from './assets/ic_general_arrow_down.svg';

class CustomAppBar extends Component {
  state = {
    showLogout: false
  };

  dropdownRef = createRef();

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = event => {
    if (this.dropdownRef && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ showLogout: false });
    }
  };

  handleToggleDropdown = () => {
    this.setState(prevState => ({ showLogout: !prevState.showLogout }));
  };

  render() {
    const { showLogout } = this.state;
    const { translate: t, toggleSidebar: toggleMenu } = this.props;
    const userTypeTranslation = `userType.${localStorage.getItem('userType')}`;

    return (
      <div className={styles.menu}>
        {/* Phones only (CSS): the menu is a pull-out drawer there. */}
        <button type="button" className={styles.menuButton} onClick={toggleMenu} aria-label={t('appBar.menu')}>
          <MenuIcon />
        </button>
        <div className={styles.brand}>
          <img className={styles.logo} src={logo} alt="Observatorio" />
          <span className={styles.title}>Administrador de la Base de datos de proyectos</span>
        </div>
        <span className={styles.version}>v{process.env.REACT_APP_VERSION}</span>
        <div ref={this.dropdownRef}>
          <div onClick={this.handleToggleDropdown} className={styles.user}>
            <div>
              <h2 className={`${styles.name} ${styles.profile}`}>{localStorage.getItem('name')}</h2>
              <h2 className={`${styles.type} ${styles.profile}`}>{t(userTypeTranslation)}</h2>
            </div>
            <img className={styles.arrow} src={arrow} />
          </div>
          {showLogout && <Logout />}
        </div>
      </div>
    );
  }
}

CustomAppBar.propTypes = {
  toggleSidebar: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired
};

export default connect(
  undefined,
  { userLogout, toggleSidebar }
)(translate(CustomAppBar));
